// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandsSection_root__4UePQ","root--editMode":"BrandsSection_root--editMode__NuJUR","slider":"BrandsSection_slider__TahlM","rotation":"BrandsSection_rotation__1KlhK"};